import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy} from '@angular/core';

/**
 *  Displays a visual indication (spinner etc.) while waiting for an asynchronous action
 *  (usually for an response to request to the server) to complete;
 *
 *  Usage :
 *  1.Place the attribute selector on a container element (like div) that we want the spinner to pe place relative to it);
 *  2.Give the container element as a style a non static position value(preferably position : relative)
 *  3.Bind the attribute to an boolean variable that controls the display of the spinner.
 *  pesudo code example :
 *  <div class="position-relative" [busyIndicator]="isLoaderShown">
 *      ....
 *      .....
 * </div>
 **/

@Component({
	// tslint:disable-next-line:component-selector
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: '[busyIndicator]',
	templateUrl: 'busy.indicator.component.html',
	styleUrls: ['./busy.indicator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class BusyIndicatorComponent implements OnChanges, OnDestroy{
	@Input() busyIndicator: boolean = false;
	@Input() waitSeconds:number;

	public timeArrived:boolean;
	private waitTimer;

	constructor(private cd:ChangeDetectorRef){
	}

	ngOnDestroy(): void {
		if (this.waitTimer){
			clearTimeout(this.waitTimer);
		}
	}
	ngOnChanges(){
		if (this.waitSeconds){
			this.timeArrived=false;
			this.waitTimer = setTimeout(()=>{
				this.timeArrived=true;
				this.waitTimer=undefined;
				this.cd.markForCheck();
			},this.waitSeconds*1000);
		}else{
			this.timeArrived=true;
		}
	}
}
